import { useState } from "react"
import { Button, Collapse, Stack } from "react-bootstrap"

type MenuButtonProps = {
    id         :string
    Icon?       :any
    checked?    :boolean
    text       :string
    onClicked?  :(id:string) => void
    children?  :any | null
}

const MenuButton:React.FC<MenuButtonProps> = ( {id="", Icon, checked=false,text="", onClicked=(id="")=>{}, children}) => {
    const [open,setOpen] = useState(false)
    const color = checked ? "#007bff":"#565656"
    const bgColor = checked ? "#e1e1e1": ""

    const _onClicked = () => {
        if (typeof children !== 'object')
            onClicked(id)
        else
        {
            setOpen(!open)
            //console.log(open)
        }
    }
    return (
        <>
        <Button 
            id={id} 
            variant=""
            onClick={ _onClicked }
            style={{
                backgroundColor: bgColor, 
                padding: "10px 20px",
                color:color, 
                fontSize:"large", 
                fontWeight:"500", 
                width:"270px"}
            }>
            <Stack gap={4} direction="horizontal">
                {Icon && <Icon stroke={color}/>}
                {!Icon && <div style={{paddingLeft:'25px'}}/>}
                {text !== null && text}
            </Stack>
        </Button>
        <Collapse in={open}>
            <div>{children}</div>
        </Collapse>
        </>
    )
}

export default MenuButton